<template>
	<div class="job-inquiries-main">
		<div class="close-button-container" @click="hideLeftContainer ^= true" :style="{ top: '12px', left: `${hideLeftContainer ? 37 : 237}px` }">
			<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
				:style="{ transform: `rotate(${hideLeftContainer ? '180' : '0'}deg)` }" />
		</div>

		<div class="left-container" :style="{ maxWidth: hideLeftContainer ? '0' : `${leftWidth}px`, minWidth: hideLeftContainer ? '0' : `${leftWidth}px`,
			padding: `${hideLeftContainer ? 0 : 5}px` }">
			<div class="button-section">
        <button>Reset</button>
        <button @click="refreshClicked">Search</button>
      </div>

			<div class="filter-section">
        <Dropdown placeholder="Search Criteria" :items="searchCriteriaItems" itemKey="Search Criteria" :selectedObject.sync="filteredSearchCriteria"
          :errorMessage.sync="searchCiteriaError" :isRequired="true" />
        <Input :placeholder="filteredSearchCriteria ? filteredSearchCriteria['Search Criteria'] : ''" :inputValue.sync="searchItem" />
        <div class="search-box" Input placeholder="Search"/>
        <Dropdown placeholder="View Options" :items="viewOptionItems" itemKey="View Option" :selectedObject.sync="filteredViewOption"
          :errorMessage.sync="viewOptionError" :isRequired="true" />
        <Dropdown placeholder="Date Field" :items="dateOptionItems" itemKey="Date Field" :selectedObject.sync="filteredDateOption"
          :errorMessage.sync="dateOptionError" :isRequired="true" /> 
        <DateTimePicker title="From" :showTime="false" style=" justify-content: flex-start;min-width:-webkit-fill-available;" :value.sync="startDate"/>
        <DateTimePicker  title="To" :showTime="false" style="margin-right: 14px; margin-left: 15px; " :value.sync="endDate"/>
        <Dropdown placeholder= "Import/Export" :isRequired="true"/>
        <Dropdown placeholder= "Cargo Type" :isRequired="true" />
      </div>

			<div style="display: flex; width: 100%; height: 150px; min-height: 150px">
        <Filters title="JobType" :tableData="jobTypeList" itemKey="JobType" itemDesc="Description" :selectedObject.sync="filteredJobType "
          @confirmClicked="jobTypeConfirm" />
        <Filters title="Customer" :tableData="customerList" itemKey="Customer Code" itemDesc="Customer Name" :selectedObject.sync="filteredCustomer"
          @confirmClicked="customerConfirm" />
      </div>

      <div class="checkbox-section" style=" padding-top: 30px; padding-left: 20px;">
        <CheckBox title="Hide Job Details" :isChecked.sync="removeJobDetails" />
        <CheckBox title="Hide Job Status" :isChecked.sync="removeJobStatus" />
        <CheckBox title="Hide Documents" :isChecked.sync="removeDocuments" />        
				<CheckBox title="Hide Customs" :isChecked.sync="removeCustoms" />	
				<CheckBox title="Hide FCL Delivery" :isChecked.sync="removeFCL" />
				<CheckBox title="Hide LCL Delivery" :isChecked.sync="removeLCL" />
					
      </div>
		</div>

		<div class="right-container" :style="{ maxWidth: `${hideLeftContainer ? '100%' : 'calc(100% - 200px)'}` }">
			<div class="top-filter">
				<div class="top-filter-container">
					<div class="top-filter-row">
						<div class="top-filter-title">Search Criteria</div>
						<div style="margin-right: 3px">:</div>
						<div>{{ filteredSearchCriteria ? filteredSearchCriteria['Search Criteria'] : '-' }}</div>&nbsp;
						<div>- {{ searchItem }}</div>
					</div>
					<div class="top-filter-row">
						<div class="top-filter-title">Job Type</div>
						<div style="margin-right: 3px">:</div>					
						<div :title="selectedJobType.length > 0 ? selectedJobType.map((j) => { return j['JobType'] }).join(', ') : 'All'" class="top-filter-item">{{ selectedJobType.length > 0 ? selectedJobType.map((j) => { return j['JobType'] }).join(', ') : 'ALL' }} </div>
					</div>
					<div class="top-filter-row">
						<div class="top-filter-title">Job Status</div>
						<div style="margin-right: 3px">:</div>
						<div>{{filteredViewOption ? filteredViewOption['View Option'] : '-'}} </div>
					</div>
				</div>
				<div class="top-filter-container">
					<div class="top-filter-row">
						<div class="top-filter-title">Customer</div>
						<div style="margin-right: 3px">:</div>
						<div :title="selectedCustomer.length > 0 ? selectedCustomer.map((c) => { return c['Customer Code'] }).join(', ') : 'All'" class="top-filter-item">{{ selectedCustomer.length > 0 ? selectedCustomer.map((c) => { return c['Customer Code'] }).join(', ') : 'ALL' }} </div>
					</div>
					<div class="top-filter-row">
						<div class="top-filter-title">Date Options</div>
						<div style="margin-right: 3px">:</div>
						<div>{{ filteredDateOption ? filteredDateOption['Date Field'] : '-' }}</div>
					</div>
					<div class="top-filter-row">
						<div class="top-filter-title">Total Jobs</div>
						<div style="margin-right: 3px">:</div>
						<div>{{ jobInquiryList.length }}</div>
					</div>
				</div>				
			</div>
			<!-- Tabulator -->
			<div class="tabulator-container" :style="{ margin: '5px 0', maxHeight: hideTabulator ? '67px' : 'calc(100% - 310px)' }">
				<div class="close-button-container" @click="hideTabulator ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideTabulator ? '270' : '90'}deg)` }" />
				</div>

				<!-- Your UI -->
				<Tabulator :tableData="jobInquiryList"  :multiSelect="1" @rowSelected="jobInquirySelected" tableID="jobInquiries"
					:style="{ opacity: hideTabulator ? '0' : '1', transition: '0.3s', zIndex: hideTabulator ? '-1' : '10' }" />
				<div v-if="selectedJobInquiry" :style="{ display: 'flex', overflow: 'auto', width: 'calc(100% - 25px)', position: 'absolute',
					top: '5px', opacity: hideTabulator ? '1' : '0', transition: '0.3s', zIndex: hideTabulator ? '10' : '-1' }">
					<div style="min-width: 1px; background-color: rgba(0,0,0,0.5); height: 50px"></div>
					<div class="tabulator-selected" style="background-color:rgba(0, 255, 0, 0.71);" v-for="k in Object.keys(selectedJobInquiry)" :key="k">
						<div style="border-bottom: 1px solid rgba(0,0,0,0.5); padding: 3px">{{ k }}</div>
						<div style="padding: 3px;">{{ selectedJobInquiry[k] }}</div>
					</div>
				</div>
				<div v-if="jobInquiryList.length == 0" class="empty-watch-list"></div>
			</div>
			<!-- Job Details -->
			<div class="job-details-container" v-if="!removeJobDetails" :style="{ marginBottom: '5px', maxHeight: hideJobDetails ? '25px' : 'calc(100% - 155px) ', overflow: hideJobDetails ? 'hidden' : 'auto', backgroundColor: hideJobDetails ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">				
				<div class="close-button-container" @click="hideJobDetails ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideJobDetails ? '270' : '90'}deg)` }" />
				</div>
				
				<div class="job-details" v-if="!hideJobDetails">
					<div class="job-details-column" v-for="c in detailsColumn" :key=c>
						<Input v-for="i in c" :key="i" :placeholder="i['key']" :inputValue="i['val']" :isDisabled="true" />
					</div>
				</div>
				<div v-else>
					<div style="color:white; background-color:#43a85c;border-radius: 5px; ">Job Details</div>
						</div>
				<!-- Your UI -->

			</div>
			<!-- Job Status -->
			<div class="job-status-container"  v-if="!removeJobStatus" :style="{ marginBottom: '5px', maxHeight: hideJobStatus ? '25px' : 'calc(100% - 155px)', overflow: hideJobStatus ? 'hidden' : 'auto',backgroundColor: hideJobStatus ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">
				<div class="close-button-container" @click="hideJobStatus ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideJobStatus ? '270' : '90'}deg)` }" />
						
				</div>
				<div class="jobstatuscontainer" v-if="!hideJobStatus" >
					<Tabulator tableTitle="Job Status" :tableData="JobStatusList" :multiSelect="1" tableID="jobStatus"
						:style="{ opacity: hideJobStatus ? '0' : '1', transition: '0.3s', zIndex: hideJobStatus ? '-1' : '10' }" />
              </div>
              <div v-else>
                <div style="color:white; background-color:#43a85c;border-radius: 5px; ">Job Status - {{ JobStatusList.length }} Records</div>
              </div>

				<!-- Your UI -->
			</div>
			<!-- Documents -->
			<div class="documents-container" v-if="!removeDocuments" :style="{marginBottom: '5px', maxHeight: hideDocuments ? '25px' : 'calc(100% - 155px)', overflow: hideDocuments ? 'hidden' : 'auto', backgroundColor: hideDocuments ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">
				<div class="close-button-container" @click="hideDocuments ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideDocuments ? '270' : '90'}deg)` }" />
				</div>
					<div v-if="!hideDocuments">
						<Tabulator tableTitle="Job Documents" :tableData="DocumentsList" :hideColumns="[ 'AttImage' ]" :multiSelect="1" :style="{ opacity: hideDocuments ? '0' : '1', transition: '0.3s', zIndex: hideDocuments ? '-1' : '10' }"
							tableID="documents" />
					</div>
					<div v-else>
						<div style="color:white; background-color:#43a85c;border-radius: 5px; ">Documents - {{ DocumentsList.length }} Records</div>
					</div>
				<!-- Your UI -->
			</div>
			<!-- Customs -->
			<div class="custdeclare-container" v-if="!removeCustoms" :style="{marginBottom: '5px', maxHeight: hideCusDeclare ? '25px' : 'calc(100% - 155px)', overflow: hideCusDeclare ? 'hidden' : 'auto', backgroundColor: hideCusDeclare ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">
				<div class="close-button-container" @click="hideCusDeclare ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideCusDeclare ? '270' : '90'}deg)` }" />
				</div>
					<div class="jobstatuscontainer" v-if="!hideCusDeclare">
						<Tabulator tableTitle="Customs Declaration" :tableData="CustomsDeclarationList" :multiSelect="1" :style="{ opacity: hideCusDeclare ? '0' : '1', transition: '0.3s', zIndex: hideCusDeclare ? '-1' : '10' }"
							tableID="customs" />
					</div>
					<div v-else>
						<div style="color:white; background-color:#43a85c;border-radius: 5px; ">Customs Declaration - {{ CustomsDeclarationList.length }} Records</div>
					</div>			
			</div>
			<div class="FCL-container" v-if="!removeFCL" :style="{marginBottom: '5px', maxHeight: hideFCL ? '25px' : 'calc(100% - 155px)', overflow: hideFCL ? 'hidden' : 'auto', backgroundColor: hideFCL ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">
				<div class="close-button-container" @click="hideFCL ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideFCL ? '270' : '90'}deg)` }" />
				</div>
				<div class="fcldeliverycontainer" v-if="!hideFCL">
					<Tabulator tableTitle="FCL Delivery" :tableData="jobFCLList" :multiSelect="1" :style="{ opacity: hideFCL ? '0' : '1', transition: '0.3s', zIndex: hideFCL ? '-1' : '10' }"
						tableID="FCL" />
					</div>
					<div v-else>
						<div style="color:white; background-color:#43a85c;border-radius: 5px; ">FCL Delivery - {{ jobFCLList.length }} Records</div>
					</div>			
			</div>
			<!-- LCL container -->
			<div class="LCL-container" v-if="!removeLCL" :style="{marginBottom: '5px', maxHeight: hideLCL ? '25px' : 'calc(100% - 155px)', overflow: hideLCL ? 'hidden' : 'auto', backgroundColor: hideLCL ? '#28a745' : 'white'  }"
				@scroll="containerScrolled">
				<div class="close-button-container" @click="hideLCL ^= true">
					<img class="close-left" src="https://img.icons8.com/metro/26/000000/double-left.png" height="15" width="15"
						:style="{ transform: `rotate(${hideLCL ? '270' : '90'}deg)` }" />
				</div>
					<div class="lcldeliverycontainer" v-if="!hideLCL">
						<Tabulator tableTitle="LCL Delivery" :tableData="jobLCLList" :multiSelect="1" :style="{ opacity: hideLCL ? '0' : '1', transition: '0.3s', zIndex: hideLCL ? '-1' : '10' }"
							tableID="LCL" />
						</div>
						<div v-else>
							<div style="color:white; background-color:#43a85c;border-radius: 5px; ">LCL Delivery - {{ jobLCLList.length }} Records</div>
						</div>			
			</div>
				
		</div>

		<Loader :isVisible.sync="loading" :loadingText="loadText" />
	</div>

</template>

<script>
/* eslint-disable */
import Dropdown from '@/components/Dropdown.vue';
import Input from '@/components/Input.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import CheckBox from '@/components/CheckBox.vue';
import Loader from '@/components/Loader.vue';
import Tabulator from '@/components/Tabulator.vue';
import Filters from '@/components/Filters.vue';

export default {
	components: {
		Dropdown, Input, DateTimePicker, CheckBox, Loader, Tabulator, Filters
	},
	props: {
		leftWidth: { type: Number, default: 200 },

		hideLeftContainer: { type: Boolean, default: false },
		hideRightContainer: { type: Boolean, default: false },
		hideTabulator: { type: Boolean, default: false },
		hideJobDetails: { type: Boolean, default: true },
		removeJobDetails: { type: Boolean, default: false },
		hideJobStatus: { type: Boolean, default: true },
		removeJobStatus: { type: Boolean, default: false },
		hideDocuments: { type: Boolean, default: true },
		removeDocuments: { type: Boolean, default: false },	
		DocumentsList: { type: Array, default: function() { return [] }  },
		JobStatusList: { type: Array, default: function() { return [] }  },		
		hideCusDeclare: { type: Boolean, default: true },
		hideLCL: { type: Boolean, default: true },
		hideFCL: { type: Boolean, default: true },
		removeLCL: { type: Boolean, default: false },
		removeFCL: { type: Boolean, default: false },
		removeCustoms: { type: Boolean, default: false },
		jobInquiriesItem: { type: Object, default: function() { return {} } },

		loadText: { type: String, default: '' },
		loading: { type: Boolean, default: false },

		searchItem: { type: String, default: '' },
		
    searchCriteriaItems: { type: Array, default: function() { return [] } },
    viewOptionItems: { type: Array, default: function() { return [] } },
    dateOptionItems: { type: Array, default: function() { return [] } },

    jobDetailsList: { type: Array, default: function() { return [] } },
    jobTypeList: { type: Array, default: function() { return [] } },
		selectedJobType: { type: Array, default: function() { return [] } },		
    customerList: { type: Array, default: function() { return [] } },
		selectedCustomer: { type: Array, default: function() { return [] } },
		jobInquiryList: { type: Array, default: function() { return [] } },	
		CustomsDeclarationList : { type: Array, default: function() { return [] } },
		jobFCLList : { type: Array, default: function() { return [] } },
		jobLCLList : { type: Array, default: function() { return [] } },

 
		selectedJobInquiry: { type: Object, default: function() { return null } },    
    startDate: { type: Date, default: function() { return null } },
    endDate: { type: Date, default: function() { return null } },

		filteredDateOption: { type: Object, default: function() { return null } },
		filteredJobType: { type: Object, default: function() { return null } },
		filteredCustomer: { type: Object, default: function() { return null } },
    dateOptionError: { type: String, default: '' },
    filteredViewOption: {type: Object, default:function() {return{} } },
    filteredSearchCriteria: { type: Object, default: function() { return null } },
		searchCiteriaError: { type: String, default: '' },

		detailsColumn: { type: Array, default: function() { return [] } },
	},
	methods: {
		containerScrolled: function(e) {
			var target = e.target;
			var scrollTop = target.scrollTop;
			var closeBtn = target.children[0];
			
			closeBtn.style.top = `${scrollTop}px`;
		},
		refreshClicked: async function() {
			var jobTypes = this.selectedJobType.map((j) => { return j['JobType'] });
			var custlist = this.selectedCustomer.map((c) => {return c['Customer Code']});
			console.log(jobTypes);
			console.log(custlist);
			var jobTypesCombined = jobTypes.join(',');
			var custlistcombined = custlist.join(',');
			console.log(jobTypesCombined);
			console.log(custlistcombined);

		

		

			var error = 0;

			if (!this.filteredSearchCriteria) {
				this.searchCiteriaError = 'Search Criteria is required';
				error++;
			}

			if (!this.filteredDateOption) {
				this.dateOptionError = 'Date Option is required';
				error++;
			}
			
      if (error == 0) {
				var jobTypeToPost = '';
				var customerToPost = '';

				this.selectedJobType.forEach((j) => { jobTypeToPost += `${j['JobType']},` });
				this.selectedCustomer.forEach((c) => { customerToPost += `${c['Customer Code']},` });

				if (error == 0) {
					var postData = {
						'datefield': this.filteredDateOption['Date Field'].toUpperCase(),
						'stjobdate': this.$dateTime.getDateTime(this.startDate, 'yyyy-MM-dd'),
						'edjobdate': this.$dateTime.getDateTime(this.endDate, 'yyyy-MM-dd'),
						'sysjobtype': jobTypeToPost.substring(0, jobTypeToPost.length - 1), 
						'customer': customerToPost.substring(0, customerToPost.length - 1),
						'searchby': this.filteredSearchCriteria['Search Criteria'],
						'searchvalue': this.searchItem
					};

					this.jobInquiriesItem = postData;

					this.loading = true;
					this.loadText = 'Getting Job Inquiries';
					var jobInquiries = await this.$apiCallV2(`/JobInquiries/GetJobInquiries`, postData);
					this.jobInquiryList = jobInquiries.data;
					this.loading = false;

					// if (jobInquiries.data) {
					// 	this.jobsFromAPI = jobInquiries.data.JobInquiries.Job;
					// } else {
					// 	this.allJobs = [];
					// }

					// if (jobInquiries.data) {
					// 	this.totalJob = jobInquiries.data.JobInquiries.Job.length;
					// } else {
					// 	this.totalJob = 0;
					// }
				}
			}
    },
		jobTypeConfirm: function(e) {
			this.selectedJobType = e;
			console.log(this.selectedJobType);
	
		},
		tabulatorSelected: function(item){
      this.selectedData = item;
    },
		customerConfirm: function(e) {
		  this.selectedCustomer = e;
			console.log(this.selectedCustomer);
		},
		jobInquirySelected: async function(e) {
			if (e) {
				console.log(e);
				this.selectedJobInquiry = e;				
				this.hideTabulator = true;
				this.hideJobDetails = false;
				this.detailsColumn = [];
				
				this.loading = true;

				var jobDetails = await this.$apiCallV2(`/JobInquiries/GetJobDetails?jobno=${e['Job No']}`);
				this.jobDetailsList = jobDetails.data['JobDetails']['Job'];
				console.log(this.jobDetailsList);

				var max = Math.ceil(Object.keys(this.jobDetailsList).length / 4);
				var index = 0;
				var column = [];
				console.log(Object.keys(this.jobDetailsList).length);
				
				Object.keys(this.jobDetailsList).forEach((j) => {
					column.push({
						'key': j,
						'val': this.jobDetailsList[j]
					});
					index++;				
					if (index == max) {
						this.detailsColumn.push(column);
						column = [];
						index = 0;
					}
				});
				if (column.length > 0) {
					this.detailsColumn.push(column);
				}

				this.loadText = 'Getting Customs Declaration';
				

				var customsDeclaration = await this.$apiCallV2(`/JobInquiries/GetCustomsDeclaration?jobno=${e['Job No']}`);
				this.CustomsDeclarationList = customsDeclaration.data;

				this.loadText = 'Getting Customs Declaration';

				var status = await this.$apiCallV2(`/JobInquiries/GetJobStatus?viewby&jobnoarray=${e['Job No']}`);
				this.JobStatusList = status.data;

				this.loadText = 'Getting Job Status';

				var FCL = await this.$apiCallV2(`/JobInquiries/GetJobFCLDelivery?jobno=` + `${e['Job No']}`);
				this.jobFCLList = FCL.data;

					this.loadText = 'Getting FCL List';

				var LCL = await this.$apiCallV2(`/JobInquiries/GetJobLCLDelivery?jobno=` + `${e['Job No']}`);
				this.jobLCLList = LCL.data;

					this.loadText = 'Getting LCL List';
				
				this.loading = false;
			}
		}
	},
	async mounted() {
		 this.loading = true;

    this.loadText = 'Getting Search Criteria';
    var searchCriteria = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBINQUIRY_SEARCH');
    this.searchCriteriaItems = searchCriteria.data;

    this.loadText = 'Getting View Option';
    var viewOption = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBINQUIRY_VIEWOPTION');
		this.viewOptionItems= viewOption.data;

    this.loadText = 'Getting Date Option';
    var dateOption = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBINQUIRY_DATEFIELD');
    this.dateOptionItems= dateOption.data;
    console.log(this.dateOptionItems);

    this.loadText = 'Getting Job Type';
    var jobType = await this.$apiCallV2('/JobMilestones/GetListMaster?master=SYSTEM_JOBTYPE');
    this.jobTypeList = jobType.data;

    this.loadText = 'Getting Customers';
    var customer = await this.$apiCallV2('/JobMilestones/GetListMaster?master=BILLCUSTNAME');
		this.customerList = customer.data;

		// this.loadText = 'Getting Job List';
    // var jobs = await this.$apiCallV2('/GetJobInquiries/GetListMaster?master=datefield');
		// this.jobList = jobs.data;

    this.loading = false;

		this.filteredSearchCriteria = this.searchCriteriaItems[3];
		this.filteredViewOption = this.viewOptionItems[0];
		this.filteredDateOption = this.dateOptionItems[1];

		this.startDate = new Date(2020,9,1,0,0);
		this.endDate = new Date(2021,1,1,0,0);

			// var custDec = await this.$apiCallV2(`/JobInquiries/GetCustomsDeclaration`,
			// 			model["data"]);
			// 		this.custDecList = custDec.data;

		// this.loadText = 'Getting Custom Declaration';
		// var jobStatus = await this.$apiCallV2(`/JobInquiries/GetJobStatus?jobno=${}&viewby=${}`);
		// this.jobStatusList = jobStatus.data;
		
		
		
		
	},
	watch: {
	}
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.job-inquiries-main {
	display: flex;
	padding: 10px 45px;
	font-size: 12px;

	> .left-container {
		min-width: 200px;
		max-width: 200px;
		background-color: white;
		margin-right: 5px;
		border-radius: 5px;
		position: relative;
		transition: $transition-time;
		padding: 5px;
		overflow-x: hidden;

		> .button-section {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;

			> button {
				margin: 0 5px;
				flex-grow: 1;
			}
		}

		> .filter-section {
			margin-top: 10px;
		}
	}

	> .right-container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		transition: $transition-time;

		> div {
			background-color: white;
			border-radius: 5px;
			width: 100%;
			height: 100%;
			transition: $transition-time;
			position: relative;
			padding: 5px;
			
		}
		

		> .top-filter {
			padding: 5px;
			height: fit-content;
			display: flex;
			

			> .top-filter-container {
				width: 100%;
				margin: 0 3px;
				display: flex;
				flex-direction: column;

				> .top-filter-row,>.job-details-row {
					display: flex;
					

					> .top-filter-title {
						width: 110px;						
					}
						>.top-filter-item{
							text-overflow: ellipsis;
							overflow-x: hidden;
							white-space: nowrap;							
							max-width: 180px;														
							
           }
				}				
			}
		}
		.empty-watch-list{
			  position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(200,200,200);
				opacity: 0.75;
        z-index: 99;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bolder;
        font-size: 15px;
		}

	

		> .job-details-container {
			> .job-details {
				display: flex;

				> .job-details-column {
					width: 100%;
					margin-right: 5px;
				}
			}
		}
	}
	
}

.close-button-container {
	cursor: pointer;
	position: absolute;
	background-color: white;
	border: 1px solid rgba(0,0,0,0.5);
	border-radius: 100%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;
	top: 2px;
	right: 3px;
	transition: $transition-time;

	> img {
		transition: $transition-time;
	}
}

.tabulator-selected {
	border-color: rgba(0,0,0,0.5);
	border-width: 1px 1px 1px 0px;
	border-style: solid;
	min-width: fit-content;
	text-align: center;
}
</style>